export default {
    namespaced: true,
    state: () => ({
        countrieslist: []
    }),
    mutations:
    {
        SET_COUNTRIESLIST(state, val) {
            state.countrieslist = val
        },
    }
}